module.exports = __webpack_public_path__ + "img/yt-play-icon.a838c09.png";